module.exports = __webpack_public_path__ + "img/img_icon_89.261ea8e0.png";